<div class="tile-container">
  <div class="tile-title">
    <p [style.color]="tile?.color">{{ tile?.title }}</p>
  </div>
  <div class="tile-content">
    <p [style.color]="tile?.color">{{ tile?.content }}</p>
  </div>
</div>
